import { useEffect } from 'react'
import { getBoardVariableDataSerieValues } from '../../../services/sKPI/dataserie.service';
import moment from 'moment';
import { action_setBoardChartContainerIdSelected } from '../../../reducers/actions/KPI/actions';
import { useDispatch } from 'react-redux';
import { firstDayNextMonthAYearBefore } from '../../../common/Helpers';
import { enum__BoardCalendarFilter, enum__ComponentType } from '../../../common/Dictionaries';
import { getBoardComponentInfoRecursiveValues, getLogroLimites } from '../../../services/sKPI/board.service';
import { useTranslation } from 'react-i18next';

const useSetInicialValues = (boardId, elementId, listComponentTypeConfig, boardCalendarFilterConfig, defaultAggregation, componentContent, contextualChart, chartDataConfig, setChartDataConfig, acronim_titles, reportMode) => {    
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    
    useEffect(()=> {
        const toNums = (arr) => (arr ?? []).map(Number).filter(Number.isFinite);

        const safeMax = (arr, fallback = 0) => {
            const nums = toNums(arr);
            return nums.length ? Math.max(...nums) : fallback;
        };

        // “redondeo bonito” hacia arriba, pero seguro cuando max <= 0
        const niceCeil = (max) => {
            const m = Number(max);
            if (!Number.isFinite(m) || m <= 0) return 0;
            const p = Math.pow(10, Math.floor(Math.log10(m)));
            return p * Math.ceil(m / p);
        };

        const doIt = async () => {
            let selectedGaugeDataPoint = null;
            let lastGaugeDataPoint = null;
            let _baseSeries = null;
            let listSeriesX = null;
            let listSerieTimeY = null;
            let _baseSerieNames = null;
            let inputParam_ComponentContent = componentContent;

            let calendarFilterStartDate = boardCalendarFilterConfig.value.periodEndsDate !== null ?
            moment(firstDayNextMonthAYearBefore(boardCalendarFilterConfig.value.periodEndsDate)).format('MM/DD/YYYY') : null;
    
            let calendarFilterEndDate = boardCalendarFilterConfig.value.periodEndsDate !== null ?
            moment(boardCalendarFilterConfig.value.periodEndsDate).format('MM/DD/YYYY') : null;
       
            if (contextualChart === false) {
                await getBoardComponentInfoRecursiveValues(boardCalendarFilterConfig, boardId, enum__ComponentType.OCR_CHART_GAUGE, elementId, listComponentTypeConfig.dataserieId, enum__BoardCalendarFilter.FIXED_MONTH, calendarFilterStartDate, calendarFilterEndDate).then((response) => {   
                    inputParam_ComponentContent = response.data.data[0];
                }).catch((e) => { });
            }
          
            try {
                await getLogroLimites().then((response) => {  
                    selectedGaugeDataPoint = inputParam_ComponentContent ? (inputParam_ComponentContent.items.length > 0 ?
                        (inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.length - 1 : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.length -1 : 0) : 0))
                    : 0): 0;

                    lastGaugeDataPoint = inputParam_ComponentContent ? (inputParam_ComponentContent.items.length > 0 ?
                        (inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.length - 1 : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.length -1 : 0) : 0))
                    : 0): 0

                    _baseSeries = [
                        {
                            id: 1,
                            name: acronim_titles.acronim_s1_real.acronim,
                            type: "column",
                            data: inputParam_ComponentContent?.items.length > 0 ? (inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.map(({ displayValue }) => displayValue) : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.map(({ displayValue }) => displayValue) : [])) : []
                        },
                        {
                            id: 2,
                            name: acronim_titles.acronim_s1_valueGoal.acronim,
                            type: "line",
                            data: inputParam_ComponentContent?.items.length > 0 ? (inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.map(({ valueGoal }) => valueGoal) : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.map(({ valueGoal }) => valueGoal) : [])) : []
                        },
                        {
                            id: 3,
                            name: acronim_titles.acronim_s1_valueGoalPercent.acronim,
                            type: "line",
                            data: inputParam_ComponentContent?.items.length > 0 ? (inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.map(({ valueGoalPercent }) => valueGoalPercent) : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.map(({ valueGoalPercent }) => valueGoalPercent) : [])) : []
                        },
                    ]

                    listSeriesX = inputParam_ComponentContent ? _baseSeries : []

                    listSerieTimeY = inputParam_ComponentContent?.items.length > 0 ? (inputParam_ComponentContent.items[0].l_vals !== undefined ?
                            inputParam_ComponentContent.items[0].l_vals.map(({ serieTimeStr }) => serieTimeStr) :
                            (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ?
                                inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.map(({ serieTimeStr, serieTime }) => serieTimeStr !== null ? serieTimeStr : serieTime) :
                                [])) : [];

                    const realName  = acronim_titles.acronim_s1_real.acronim;          // "S1-Real"
                    const goalName  = acronim_titles.acronim_s1_valueGoal.acronim;      // "S1-Goal"
                    const goalPName = acronim_titles.acronim_s1_valueGoalPercent.acronim;// "S1-GoalP"

                    // Ojo: ajusta los ids si en _baseSeries no coinciden
                    const realData  = _baseSeries.find(o => o.id === 1)?.data ?? [];
                    const goalData  = _baseSeries.find(o => o.id === 2)?.data ?? [];

                    // Max izquierdo considera real + goal
                    const leftMax  = niceCeil(safeMax([...realData, ...goalData], 0));

                    // Max derecho: si es porcentaje, yo lo dejaría fijo en 100
                    const rightMax = response.data.data.logroMaximo;
                    const rightMin = response.data.data.logroMinimo;

                    _baseSerieNames = [
                    // Eje izquierdo visible (para S1-Real)
                    {
                        seriesName: realName,
                        show: true,
                        min: 0,
                        max: leftMax !== 0 ? leftMax : 100,
                        tickAmount: 5,
                        title: { text: realName, style: { color: "#1F7BE8" } },
                        axisTicks: { show: true },
                        axisBorder: { show: true, color: "#1F7BE8" },
                        labels: {
                            style: { colors: "#1F7BE8" },
                            formatter: (value) => {
                                return value !== null ? parseFloat(value.toFixed(2)).toLocaleString(i18n.language) : value;
                            }
                        },
                        tooltip: { enabled: true },
                    },

                    // Eje izquierdo oculto (para S1-Goal) PERO mismo rango
                    {
                        seriesName: goalName,
                        show: false,
                        min: 0,
                        max: leftMax,
                        tickAmount: 5,
                        tooltip: { enabled: true },
                    },

                    // Eje derecho visible (para S1-GoalP)
                    {
                        seriesName: goalPName,
                        show: true,
                        opposite: true,
                        min: rightMin,
                        max: rightMax,
                        tickAmount: 5,
                        title: { text: goalPName, style: { color: "#000099" } },
                        axisTicks: { show: true },
                        axisBorder: { show: true, color: "#000099" },
                        labels: {
                            style: { colors: "#000099" },
                            formatter: (val) => (Number.isFinite(Number(val)) ? `${Number(val).toFixed(0)}%` : val),
                        },
                        tooltip: { enabled: true },
                    },
                    ];

                    setChartDataConfig({
                        listSeriesX: listSeriesX,
                        listSerieTimeY: listSerieTimeY,
                        _baseSerieNames: _baseSerieNames,
                    })
                    //[#solucion pmz#]
                    dispatch(action_setBoardChartContainerIdSelected({
                        containerId: listComponentTypeConfig.containerId,
                        dataserieId: componentContent.items.length > 0 && componentContent.items[0].l_dataserie.length > 0 ? componentContent.items[0].l_dataserie[0].dataserieId : listComponentTypeConfig.dataserieId,
                        forceOCRLoad: false,
                    })); 
                }).catch((e) => {
                    dispatch(action_setBoardChartContainerIdSelected({
                        containerId: listComponentTypeConfig.containerId,
                        dataserieId: listComponentTypeConfig.dataserieId,
                        forceOCRLoad: false,
                    }));
                });
            }
            catch (error) {
                dispatch(action_setBoardChartContainerIdSelected({
                    containerId: listComponentTypeConfig.containerId,
                    dataserieId: listComponentTypeConfig.dataserieId,
                    forceOCRLoad: false,
                }));
            }
        }
        //[#solucion pmz#]
        let mustForce = null;
        
        if (!reportMode) {
            mustForce = (listComponentTypeConfig.dataserieId == null ? listComponentTypeConfig.forceOCRLoad :  (componentContent.items.length > 0 && componentContent.items[0].l_dataserie.length > 0 ? listComponentTypeConfig.dataserieId !== componentContent.items[0].l_dataserie[0].dataserieId : false))    
        }
        else {
            mustForce = (listComponentTypeConfig.dataserieId !== null ? listComponentTypeConfig.forceOCRLoad : false)
        }

        if (((boardId !== null && elementId !== null && (listComponentTypeConfig.dataserieId !== null || componentContent.items.length > 0) && componentContent !== null && chartDataConfig !== null && chartDataConfig.listSeriesX === null)) || mustForce || listComponentTypeConfig.forceOCRLoad) {        
            doIt()
        }
    }, [boardId, elementId, listComponentTypeConfig, boardCalendarFilterConfig, defaultAggregation, componentContent, contextualChart, chartDataConfig, setChartDataConfig, acronim_titles]);
}

export {
    useSetInicialValues
}